import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

interface CloudFunctionResponse {
  status: string;
  data: any;
}

interface SignUpData {
  email: string;
  password: string;
  displayName: string;
  city: string;
  state: string;
}

export const createUser = async (signUpData: SignUpData): Promise<any> => {
  const createUserFunc = httpsCallable(firefuncs, "createUser");
  const res = await createUserFunc(signUpData);
  console.log("create User res", res.data);
  const { status, data } = res.data as CloudFunctionResponse;

  if (status === "success") {
    return data;
  }
  if (status === "error") {
    console.log("error data", data);
    throw new Error(data.errorInfo.message);
  } else {
    throw new Error("Response Error");
  }
};

interface AddUserToDBParams {
  userId: string;
  userDisplayName: string;
}

export const addUserToDB = ({
  userId,
  userDisplayName,
}: AddUserToDBParams): Promise<any> => {
  const addUser = httpsCallable(firefuncs, "addUserToDB");
  return addUser({
    id: userId,
    displayName: userDisplayName,
    city: "Austin", // todo: change to gps location
    profileBio: "",
  })
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};

export const addUserDataDocs = (
  userId: string,
  userEmail: string,
): Promise<any> => {
  const addUserData = httpsCallable(firefuncs, "addUserDataDocs");
  return addUserData({
    id: userId,
    email: userEmail,
  })
    .then((res) => console.log(res))
    .catch((err) => console.log(err));
};

export default {
  createUser,
  addUserToDB,
  addUserDataDocs,
};
